// extracted by mini-css-extract-plugin
module.exports = {"container":"projectView_container__3vO5S","title":"projectView_title__1_2Ee","content":"projectView_content__7O1JR","header":"projectView_header__3xgz1"};
    if(module.hot) {
      // 1790670316067
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  